export default "__VITE_ASSET__DMuqSU$i__"